import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import TypeConverter from '@/Utility/TypeConverter';
import TimePickerViewModel from '@/ViewModels/Controls/TimePickerViewModel';
import TimePicker from '@/Controls/TimePicker';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import { FilterInfo } from '#/DefaultViewExtensionInterfaces';
import * as DateHelper from '@/Utility/DateHelper';

export default class TimePickerFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private TimePickerViewModel = ComponentManager.getViewModel<typeof TimePickerViewModel>('TimePickerViewModel');
    private TimePicker = ComponentManager.getControl<typeof TimePicker>('TimePicker');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * @override
     */
    public viewModel: TimePickerViewModel;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.TimePickerViewModel({
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            isFocusable: this.isFocusable,
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            invalidationText: this.invalidationText,
            value: this.context.genericObject.getObservable(this.detailViewItem.name),
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            })
        })

        this.control = new this.TimePicker(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.addOverwritableToControl(this.jQueryControl, [this.detailViewItem.name]);

        this.registerDefaultValidation([this.detailViewItem.name]);
        this.registerCustomValidation([this.detailViewItem.name], this.viewModel.value, (value: string): boolean => {
            // Keine Validierung, wenn der Wert nicht in den Changes ist
            if (Object.keys(this.context.genericObject.changes()).indexOf(this.detailViewItem.name) == -1)
                return true;

            const isNullableType = TypeConverter.typeIsNullable(this.detailViewItem.dotNetTypeName) || this.detailViewItem.useInFilter;
            const validityState = (this.jQueryControl.find('input')[0] as HTMLInputElement)?.validity;
            if (!validityState?.valid) return false;
            return this.viewModel.customValidate(value, isNullableType);
        });

        return this.jQueryControl;
    }

    public getFilterInfo(): FilterInfo {
        return {
            field: this.detailViewItem.name,
            value: DateHelper.toDotNetDateTimeString(this.viewModel?.date()) || ''
        }
    }
}

ComponentManager.setFactory('TimePicker', TimePickerFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');